import { HelloBar } from "@circle-react-uikit/HelloBar";
import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

import { MarketingCampaignOffer } from "@/react/components/Layout/TrialBanner/MarketingCampaignOffer";
import { PlanTrialOffer } from "@/react/components/Layout/TrialBanner/PlanTrialOffer";
import { TrialOffer } from "@/react/components/Layout/TrialBanner/TrialOffer";
import { usePlanTrialBanner } from "@/react/components/Layout/TrialBanner/usePlanTrialBanner";
import { useTrialBanner } from "@/react/components/Layout/TrialBanner/useTrialBanner";
import { useCircleV4 } from "@/react/hooks/useCircleV4";
import { usePlanStatus } from "@/react/hooks/usePlanStatus";

import { CancellationBanner } from "./CancellationBanner";
import { ResumeBanner } from "./ResumeBanner";

export const TrialBannerV2 = () => {
  const { displayCommunitySwitcher: shouldDisplayCommunitySwitcher } =
    usePunditUserContext();
  const { shouldShowTrialBanner, isSubscriptionCancelled } = useTrialBanner();
  const { isPlanTrialActive, shouldShowPlanTrialBanner } = usePlanTrialBanner();
  const { hasActiveOffer, isCommunitySubscriptionOnGracePeriod } =
    usePlanStatus();
  const { isCircleV4 } = useCircleV4();

  const shouldShowBanner = shouldShowTrialBanner || shouldShowPlanTrialBanner;

  if (!shouldShowBanner) {
    return null;
  }

  const renderBannerContent = () => {
    if (isCommunitySubscriptionOnGracePeriod) {
      return <ResumeBanner />;
    }

    if (isSubscriptionCancelled) {
      return <CancellationBanner />;
    }

    if (hasActiveOffer) {
      return <MarketingCampaignOffer />;
    }

    if (isPlanTrialActive) {
      return <PlanTrialOffer />;
    }
    return <TrialOffer />;
  };

  // In Circle V4, each banner renders the self-contained Compass Banner, so we
  // skip the HelloBar wrapper entirely.
  if (isCircleV4) {
    return renderBannerContent();
  }

  return (
    <HelloBar
      className={classNames({
        "left-[60px]": shouldDisplayCommunitySwitcher,
        "!bg-warning-light":
          !isSubscriptionCancelled || isCommunitySubscriptionOnGracePeriod,
        "!bg-black": hasActiveOffer,
      })}
    >
      {renderBannerContent()}
    </HelloBar>
  );
};
